(function () {
    var PeriodDetailsCtrl = (function () {
        function PeriodDetailsCtrl() {
            this.init.apply(this, arguments);
        }

        PeriodDetailsCtrl.prototype = {
            init: function ($scope, $state, $stateParams, MKioskService, $q, $loading, $message) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.MKioskService = MKioskService;
                this.$q = $q;
                this.$loading = $loading;
                this.$message = $message;
                
                this.items = []; 

                if (this.$stateParams.period == 'HomeChargesNotYetReimbursed') {
                    this.title = this.$message.get('HomeChargesNotYetReimbursed')
                } else {
                    var period = moment(this.$stateParams.period, 'YYYY-MM' , 'en')
                    .locale(moment.locale())
                    .format('MMMM YYYY');

                    // NF-1004 showing good title eg. "Homes charges in March 2025"
                    // keys to use in this case:
                    // OfficeChargesIn
                    // PublicChargesIn
                    // HomeChargesIn
                    this.title = this.$message.get(this.$stateParams.type + 'ChargesIn');
                    this.title = this.title.replace('{0}', period);
                }
                

                this.loadData().then(angular.bind(this, function (periodDetails) {
                    this.chargesItems = periodDetails.Charges || [];
                    this.manualItems = periodDetails.Expenses || [];
                    
                    if ((periodDetails.Charges || []).length > 0) {
                        // if current list is for home or public charge then we need special section
                        if (this.$stateParams.type == 'Home') {
                            this.items.push({
                                type: 'section',
                                key: 'HomeChargers' 
                            })
                        }
                        if (this.$stateParams.type == 'Public') {
                            this.items.push({
                                type: 'section',
                                key: 'ChargingCards' 
                            })
                        }

                        this.items.push(...(periodDetails.Charges || []).map(i => {
                            i.type = 'charge';
                            // icon of first line
                            i.chargeIcon = this.$stateParams.type == 'Home' ? 'play_circle_filled' : 'calendar_month';
                            return i;
                        }));
                    }

                    if ((periodDetails.Expenses || []).length > 0) {
                        this.items.push({
                            type: 'section',
                            key: 'ManualEvents'
                        })

                        this.items.push(...(periodDetails.Expenses || []).map(i => {
                            i.type = 'charge';
                            // icon of first line
                            i.chargeIcon = 'calendar_month';
                            return i;
                        }));
                    }


                    /** NF-1004 - CPE/5: Returning dto 
                        public sealed class ConsumptionDetailsForPeriodResponseDto
                        {
                            public List<ConsumptionDetailBaseDto> Charges { get; } = new List<ConsumptionDetailBaseDto>();
                            public List<ConsumptionDetailBaseDto> Expenses { get; } = new List<ConsumptionDetailBaseDto>();
                        }

                        public abstract class ConsumptionDetailBaseDto
                        {
                            public Date Date { get; internal set; }
                            Time?: string // sometime not existed
                            public decimal Energy { get; internal set; } // kWk
                            public decimal Cost { get; internal set; } // eur
                        }

                        public sealed class ConsumptionDetailChargeDto : ConsumptionDetailBaseDto
                        {
                            public string Location { get; internal set; }
                        }

                        public sealed class ConsumptionDetailExpenseDto : ConsumptionDetailBaseDto
                        {
                            public Guid EventId { get; internal set; }
                            public bool ToBeReimbursed { get; internal set; }
                            public Date? ReimbursementDate { get; internal set; }
                            public string ExpenseStatement { get; internal set; }
                        }
                     */

                }), this.$message.error).finally(() => {
                    this.loaded = true;
                    this.$loading.hide();
                });;
            },
            back: function () {
                if (this.$stateParams.pre) {
                    this.$state.go(this.$stateParams.pre);
                } else {
                    this.$state.go("internal.mycharges");
                }
            },
            loadData: function () {
                this.$loading.show();
                this.loaded = false;
                return this.MKioskService.getConsumptionDetailsForPeriod(this.$stateParams.period, this.$stateParams.type);
            },
            onItemClick: function(item) {
                if (item.EventId) {
                    var title = null;
                    if (item.ExpenseStatement) {
                        title = this.$message.get('ExpensesStatementNumber').replace('{0}', item.ExpenseStatement)
                    }

                    this.$state.go("internal.eventdetail", {
                        id: item.EventId,
                        prevState: this.$state.current.name,
                        preParams: JSON.stringify(this.$stateParams),
                        title: title
                    });
                }
            }
        };
        PeriodDetailsCtrl.$inject = ['$scope', '$state', '$stateParams', 'MKioskService', '$q', '$Loading', '$message'];
        return PeriodDetailsCtrl;
    }());
    angular.module('internal.mycharges').controller('PeriodDetailsCtrl', PeriodDetailsCtrl)
})();


